import { useEffect } from 'react';
import { useIssueContextActions } from '@atlassian/jira-issue-context-service';
import { getBoardDetailViewMode } from '@atlassian/jira-software-board-common/src';

// Need to check local storage value when navigating back from backlog where view mode is set to sidebar
export const useSetViewModeFromLocalStorage = () => {
	const [, { setDetailViewAsModal }] = useIssueContextActions();
	const localStorageViewMode = getBoardDetailViewMode();

	useEffect(() => {
		if (localStorageViewMode === 'MODAL') {
			setDetailViewAsModal();
		}
	}, [localStorageViewMode, setDetailViewAsModal]);
};
